import { CallToAction } from '../../commonTypes/links';
import { NavLink } from './types';

const withOnClick = <T extends CallToAction | NavLink>(
  link: T,
  resetNav: () => void
): T => {
  const onClick: React.MouseEventHandler = (event): void => {
    resetNav();
    if (link.onClick) {
      link.onClick(event);
    }
  };
  return { ...link, onClick };
};

export default withOnClick;
